import React from 'react';

import { fixedPercentFigure } from '../../utils/percentFigure';

import { formatFigure } from 'Helpers/formatService';

import Tooltip from 'CommonComponents/Tooltip';

export default function RevenueMilestoneFields(props) {
    const tooltipContent = () => {
        return props.revenue && props.revenue.currentMilestones[props.milestoneId] ? props.revenue.currentMilestones[props.milestoneId].name : '';
    };

    // Row-level editing input handler
    const handleRowEditChange = (event) => {
        props.handleValueChange(props.milestoneId, event.target.value);
    };

    const hasMilestone = props.milestoneId in props.revenue.currentMilestones && props.revenue.currentMilestones[props.milestoneId];

    const hasPercentage = hasMilestone && typeof props.revenue.currentMilestones[props.milestoneId].percentage !== 'undefined';

    // Check if this cell should be in row editing mode
    const isInRowEditMode = props.isRowEditing;
    const currentEditValue =
        props.editedValues && props.editedValues[props.milestoneId] !== undefined
            ? props.editedValues[props.milestoneId]
            : hasPercentage
              ? Math.round(Number(props.revenue.currentMilestones[props.milestoneId].percentage) * 100) / 100
              : '';

    // Calculate live amount during editing
    const getLiveAmount = () => {
        if (!isInRowEditMode || !props.totalUncommittedValue) return 0;

        const percentage = parseFloat(currentEditValue);
        if (isNaN(percentage) || percentage <= 0) return 0;

        return (props.totalUncommittedValue * percentage) / 100;
    };

    const liveAmount = isInRowEditMode ? getLiveAmount() : hasMilestone ? props.revenue.currentMilestones[props.milestoneId].amount : 0;

    return (
        <>
            {/* Percentage column - always render */}
            <td className="tw-text-right">
                {isInRowEditMode ? (
                    <input
                        type="number"
                        step="1"
                        name={`revenue_${props.revenue.id}_milestone_${props.milestoneId}_row_edit`}
                        className="tw-block tw-w-full tw-min-w-14 tw-rounded-lg tw-text-sm tw-bg-grey/25 -tw-my-1 tw-px-2 tw-py-1 tw-text-charcoal focus:tw-outline-0"
                        id={`revenue_${props.revenue.id}_milestone_${props.milestoneId}_row_edit`}
                        placeholder="Enter percentage"
                        value={currentEditValue}
                        onChange={handleRowEditChange}
                    />
                ) : hasPercentage ? (
                    fixedPercentFigure(props.revenue.currentMilestones[props.milestoneId].percentage)
                ) : (
                    ''
                )}
            </td>

            {/* Amount column */}
            <td className="tw-text-right">
                <Tooltip placement="bottom-start" tooltipContent={tooltipContent()} backgroundClass="tw-bg-blue" tooltipType="text" allowTooltip={hasMilestone}>
                    <span>{formatFigure(isNaN(liveAmount) ? 0 : liveAmount)}</span>
                </Tooltip>
            </td>
        </>
    );
}
